module.exports = __webpack_public_path__ + "img/west.d87932fe.jpg";